<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper reports" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div class="modal reports" style="top: 0;">
				<div class="modalContent">
					<div class="modalDecoration"></div>
					<div class="functionPanel unselectable">
						<a class="closeWindow clickable" @click="onModalClose(close)">
							<div class="decoration" content="Закрыть" v-tippy="{placement: 'bottom'}">
								<i class="action_cancel_tiny_flat_black"></i>
							</div>
						</a>
					</div>
					<div>
						<div class="contentHeader unselectable">
							<h2 class="msAntiScroll drag" draggable="true">
								<span>ЦЕНТР МИРА</span>
							</h2>
						</div>
					</div>
					<div class="heightTransitionContent">
						<div class="contentTabulation">
							<div class="tabulationContent scrollable scrollingDisabled">
								<div class="scrollContentOuterWrapper disableScrolling">
									<div class="scrollContent disableScrolling">
										<div class="scrollContentInnerWrapper">
											<div ng-transclude="">
												<div class="mapCellDetails" ng-controller="mapCellDetailsCtrl">
													<div dynamic="" scrollable="" class="scrollable">
														<div class="scrollContentOuterWrapper" style="width: 610px;">
															<div class="scrollContent" dynamic-height="true" style="width: 610px; overflow-y: hidden; max-height: 662px;">
																<div class="scrollContentInnerWrapper" ng-transclude="" style="width: auto;">
																	<div ng-include="" src="'tpl/mapCellDetails/partials/header.html'">
																		<div class="mapContainer village">
																			<div ng-if="mapDetails.isWonder">
																				<h6 class="headerTrapezoidal">
																					<!-- ngIf: fieldType=='unhabitable' -->
																					<!-- ngIf: fieldType=='village' && !mapDetails.isConquered -->
																					<div ng-if="fieldType=='village' && mapDetails.isConquered" class="content" translate=""><span>Чудо света</span></div>
																				</h6>
																				<div ng-if="mapDetails.wwValues" class="rankContainer">
																					<h6 class="headerTrapezoidal">
																						<div class="content" translate=""><span>Ранг</span></div>
																					</h6>
																					<div class="rankBody">
																						<i class="cellDetails_wwRank_large_illu"></i>
																						<div class="worldWonderRank">
																							1
																						</div>
																						<div class="horizontalLine double"></div>
																						<div class="worldWonderBonus">+ 50%</div>
																					</div>
																				</div>
																				<div class="symbol_i_tiny_wrapper">
																					<i class="symbol_i_tiny_flat_white clickable" clickable="openWindow('help', {'pageId': 'MilitaryAndDiplomacy_WonderOfTheWorld'})"></i>
																				</div>
																			</div>
																			<!-- ngIf: fieldType == 'oasis' -->
																			<!-- ngIf: fieldType == 'npcVillageRobber' -->
																			<!-- ngIf: cellData.menhir -->
																			<!-- ngIf: fieldType != 'oasis' && fieldType != 'npcVillageRobber' && !mapDetails.isWonder && !cellData.menhir -->
																			<div class="wwIllu" ng-if="mapDetails.isWonder"></div>
																			<!-- ngIf: showAttack && attackingTroops.cnt == 0 -->
																			<ul class="attackContainer infoMovements unselectable troopMovements" ng-if="attackingTroops.cnt > 0">
																				<li class="infoMovementType incoming unselectable incoming_attacks">
																					<i class="movement_attack_small_flat_black"></i>

																					<div class="countdown" countdown="1726519533">03:32:36</div>
																					<div class="count">1</div>
																					<div class="ending">
																						<div class="colored"></div>
																					</div>
																				</li>
																			</ul>
																			<!-- ngIf: mapDetails.npcInfo.type == 8 -->
																			<!-- ngIf: fieldType == 'oasis' -->
																			<!-- ngIf: fieldType == 'oasis' -->
																		</div>
																	</div>
																	<div class="otherContainer village">
																		<div ng-include="" src="'tpl/mapCellDetails/partials/bodyTop.html'">
																			<div class="splitContainer village">
																				<div ng-if="fieldType == 'village' && mapDetails.wwValues">
																					<div class="contentBox worldWonderProgress">
																						<div ng-include="" src="'tpl/mapCellDetails/partials/worldWonderProgress.html'">
																							<div class="contentBoxBody">
																								<h6 class="headerTrapezoidal">
																									<div class="content">
																										<span ng-bind-html="mapDetails.wwValues.level | bidiRatio:mapDetails.wwValues.level:wonderMaxLvl">46/100</span>
																										<span translate=""><span>Уровни</span></span>
																									</div>
																								</h6>
																								<div class="progressbar" progressbar="" perc="46">
																									<!-- ngIf: ::labelIcon -->
																									<div class="progress">
																										<!-- ngIf: steps -->
																										<div class="bar positive perc " style="z-index: 2; width: 46%;"></div>
																										<div class="bar additionalBar additionalPerc"></div>
																										<div class="marker">
																											<div class="markerInner"></div>
																										</div>
																										<!-- ngIf: ::showCountdown -->
																										<!-- ngIf: ::label -->
																										<!-- ngIf: ::percTooltip -->
																									</div>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																				<div ng-if="fieldType == 'village'">
																					<div class="contentBox">
																						<div ng-include="" src="'tpl/mapCellDetails/partials/villageDetails.html'">
																							<div class="villageDetails contentBoxHeader headerColored">
																								<h6>
																									<span translate=""><span>Информация</span></span>
																									<span class="coordinateWrapper" coordinates="" x="0" y="0">
																										<a ng-if="hasLink" clickable="$root.openPage('map', 'centerId', '536887296_1715592756.1');" class="clickable">
																											<span class="coordinates coordinatesWrapper " ng-bind-html=" coord | bidiCoordinate:x:y "><span class="coordinateX">(0</span><span class="coordinatePipe">|</span><span class="coordinateY">0)</span></span>
																										</a>
																										<!-- ngIf: !hasLink -->
																									</span>
																								</h6>
																								<span class="mainVillageIndicator">
																									<!-- ngIf: village.isMainVillage -->
																								</span>
																							</div>
																							<table class="transparent contentBoxBody">
																								<tbody>
																									<tr ng-if="mapDetails.tribe != Player.TRIBE.NATAR">
																										<th translate=""><span>Владелец</span></th>
																										<td><div class="longTitle">
																											<a ng-class="{disabled: playerId <= 2 || nolink || deleted}" class="playerLink  truncated clickable" clickable="openPlayerWindow()" tooltip="" tooltip-show="false" tooltip-translate="Player.AlreadyDeleted" player-link="" playerid="1458" playername="mustdie">mustdie</a></div>
																										</td>
																									</tr>
																									<tr ng-if="mapDetails.tribe != Player.TRIBE.NATAR">
																										<th translate=""><span>Королевство</span></th>
																										<td>
																											<div class="longTitle">
																												<a ng-class="{disabled: kingdomId <= 0 || nolink}" class="kingdomLink truncated clickable" clickable="$root.openWindow('kingdom', {'kingdomId': 2}, null, true)" ng-if="mapDetails.kingdomId != 0" kingdomid="2">♔Выдры♔</a>
																												<!-- ngIf: mapDetails.kingdomId == 0 -->
																											</div>
																										</td>
																									</tr>
																									<tr>
																										<th translate=""><span>Народ</span></th>
																										<td translate="" options="3"><span>Галлы</span></td>
																									</tr>
																									<tr>
																										<th translate=""><span>Население</span></th>
																										<td>1064</td>
																									</tr>
																									<!-- ngIf: mapDetails.treasures > 0 -->
																								</tbody>
																							</table>
																						</div>
																					</div>
																					<div class="contentBox">
																						<div ng-include="" src="'tpl/mapCellDetails/partials/landDistribution.html'">
																							<div class="villageDetails contentBoxHeader headerColored">
																								<h6 translate=""><span>Распределение</span></h6>
																							</div>
																							<div class="contentBoxBody">
																								<div class="landDistributionContainer">
																									<i class="landDistribution unit_wood_large_illu"></i>
																									<span>1</span>
																								</div>
																								<div class="landDistributionContainer">
																									<i class="landDistribution unit_clay_large_illu"></i>
																									<span>1</span>
																								</div>
																								<div class="landDistributionContainer">
																									<i class="landDistribution unit_iron_large_illu"></i>
																									<span>1</span>
																								</div>
																								<div class="landDistributionContainer">
																									<i class="landDistribution unit_crop_large_illu"></i>
																									<span>15</span>
																								</div>
																							</div>
																						</div>
																					</div>
																				</div>
																				<!-- ngIf: fieldType == 'oasis' -->
																				<!-- ngIf: fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor' -->
																				<!-- ngIf: fieldType == 'unhabitable' -->
																				<!-- ngIf: fieldType == 'habitable' -->
																			</div>
																		</div>
																		<div ng-include="" src="'tpl/mapCellDetails/partials/bodyBottom.html'">
																			<!-- ngIf: fieldType == 'oasis' -->
																			<!-- ngIf: fieldType == 'village' && mapDetails.isWonder && !mapDetails.isConquered -->
																			<div class="tributeCropContainer">
																				<div class="tributes contentBox gradient ng-hide" ng-show="showTributes">
																					<div class="contentBoxBody">
																						<display-resources resources="village.tributes" treasures="village.tributeTreasures" hide-zero="true">
																							<div class="costs max1digits">
																								<span ng-if="!checkStorage">
																									<!-- ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes --><!-- ngIf: resourceVisibility[index] --><!-- end ngRepeat: (index, type) in resTypes -->
																								</span>
																								<!-- ngIf: checkStorage -->
																								<!-- ngIf: (consumption || consumption == 0) && consumption != 'false' -->
																								<!-- ngIf: population || population == 0 -->
																								<!-- ngIf: treasures || treasures == 0 -->
																								<!-- ngIf: stolenGoods || stolenGoods == 0 -->
																								<!-- ngIf: time || time == 0 -->
																								<!-- ngIf: enoughResSecs == -1 -->
																								<!-- ngIf: enoughResSecs > 0 -->
																								<!-- ngIf: capacityHint -->
																								<div class="iconButton premium npcTrade ng-hide" ng-show="showNpc != undefined"><i class="feature_npcTrader_small_flat_black"></i></div>
																							</div>
																						</display-resources>
																						<div class="barView">
																							<div class="actualTributes">0/0</div>
																							<div class="populationBar progressbar" progressbar="" type="green" perc="NaN" marker="NaN">
																								<!-- ngIf: ::labelIcon -->
																								<div class="progress">
																									<!-- ngIf: steps -->
																									<div class="bar positive perc green"></div>
																									<div class="bar additionalBar additionalPerc"></div>
																									<div class="marker">
																										<div class="markerInner"></div>
																									</div>
																									<!-- ngIf: ::showCountdown -->
																									<!-- ngIf: ::label -->
																									<!-- ngIf: ::percTooltip -->
																								</div>
																							</div>
																						</div>
																						<button clickable="fetchTributes()" ng-class="{disabled: !village.canFetchTributes || !village.allowTributeCollection || !village.protectionGranted || !activeTreasury || (!territoryConnected && village.type != Village.TYPE_GOVERNOR_NPC_VILLAGE)}" play-on-click="16" tooltip="" tooltip-translate-switch="{
																							'ContextMenu.button.fetchTribute.denied': true,
																							'ContextMenu.button.fetchTribute.unprotected': true,
																							'Tributes.VillageNotGeneratingInfluence': true,
																							'Tributes.VillageNotConnected': false
																						}" class="clickable disabled">
																							<div class="content">
																								<span ng-transclude="" class="innerText">
																									<span translate=""><span>Собрать дань</span></span>
																								</span>
																								<!-- ngIf: price > 0 || forceGoldUsage -->
																								<!-- ngIf: price == -1 && !forceGoldUsage -->
																								<div class="animationOverlay"></div>
																								<i class="checkmark action_check_small_flat_white"></i>
																								<i class="checkmark action_check_small_flat_black"></i>
																								<i class="checkmark action_check_small_flat_red"></i>
																							</div>
																						</button>
																					</div>
																				</div>
																				<!-- ngIf: sharedInformations.cropDetails != null -->
																			</div>
																			<p ng-show="error" class="error ng-hide"></p>
																			<div ng-if="fieldType == 'village' || fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor'">
																				<!-- ngRepeat: troopDetails in troopsHere -->
																			</div>
																			<!-- ngIf: sharedInformations.stationedTroops.length > 0 -->
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div class="cellActionContainer">
														<div class="iconButton centerMapButton clickable" tooltip="" tooltip-translate="CellDetails.CenterMap" clickable="openPage('map', 'centerId', '536887296_1715592756.1'); closeWindow(w.name);">
															<i class="symbol_target_small_flat_black"></i>
														</div>
														<div class="options" ng-if="options.length > 0" more-dropdown="" more-dropdown-options="getOptions()"><a class="iconButton clickable" clickable="openMoreDropdown()"><!-- ngIf: showCount --><i class="symbol_arrowDown_tiny_illu"></i></a></div>
														<div class="moreDropDownBody dropdownBody" style="top: 673px; left: 906.984px; display: block;">
															<ul>
																<li ng-repeat="option in options" clickable="openWindow('markerMenu',{'cellId': 536887296}); closeMoreDropdown()" class="clickable">Отметить поле</li>
																<li ng-repeat="option in options" clickable="openWindow('reports',{'tab': 'Search', 'villageId': 536887296}); closeMoreDropdown()" class="clickable">Отчеты</li>
																<li ng-repeat="option in options" clickable="openWindow('building',{'location': 39, 'tab': 'Send', 'destId': 536887296, destPlayerId: 662}); closeMoreDropdown()" class="clickable">Послать торговцев</li>
															</ul>
														</div>
														<button class="sendTroopsButton clickable disabled" ng-if="fieldType == 'village' || fieldType == 'oasis' || fieldType == 'npcVillageRobber' || fieldType == 'npcVillageGovernor'" clickable="openWindow('sendTroops', {'x': 0, 'y': 0 })" tooltip="" tooltip-show="true" tooltip-translate="ContextMenu.NoRallyPoint" ng-class="{disabled: !hasRallyPoint}">
															<div class="content">
																<span ng-transclude="" class="innerText">
																	<span translate=""><span>Отправить войска</span></span>
																</span>
																<!-- ngIf: price > 0 || forceGoldUsage -->
																<!-- ngIf: price == -1 && !forceGoldUsage -->
																<div class="animationOverlay"></div>
																<i class="checkmark action_check_small_flat_white"></i>
																<i class="checkmark action_check_small_flat_black"></i>
																<i class="checkmark action_check_small_flat_red"></i>
															</div>
														</button>
														<!-- ngIf: fieldType == 'habitable' && !cellData.menhir -->
														<!-- ngIf: cellData.menhir && cellData.menhir == player.data.playerId -->
														<!-- ngIf: cellData.menhir && cellData.owner == player.data.playerId -->
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="window-overlay"></div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

import Player from '@/classes/game/Player';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		Player,
		
		cancelHover: false,
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>